import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formGuid", "formWorkflowDependency", "hasWorkflowsAppAccess", "truncate"];
import UILink from 'UIComponents/link/UILink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import Routes from 'ContentUtils/Routes';
import { isSimpleWorkflowForForm } from 'ContentData/helpers/workflowsHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const WorkflowLink = _ref => {
  let {
      formGuid,
      formWorkflowDependency,
      hasWorkflowsAppAccess,
      truncate
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    flowId,
    name
  } = formWorkflowDependency;
  let url;
  let hasAccess;
  if (isSimpleWorkflowForForm(formWorkflowDependency, formGuid)) {
    url = Routes.formAutomation(formGuid);
    hasAccess = true; // This component doesn't render without forms-write access so we can assume they have form editor access
  } else {
    url = Routes.workflows(flowId, 'AUTOMATION_PLATFORM');
    hasAccess = hasWorkflowsAppAccess;
  }
  if (hasAccess) {
    return /*#__PURE__*/_jsx(UILink, Object.assign({
      external: true,
      href: url,
      truncate: truncate
    }, rest, {
      children: name
    }));
  }
  return truncate ? /*#__PURE__*/_jsx(UITruncateString, {
    children: name
  }) : /*#__PURE__*/_jsx("div", {
    children: name
  });
};
export default WorkflowLink;